import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ArticleCard from "@/components/site/ArticleCard";
import SEO from "@/components/site/SEO";
import { api } from "@/lib/api";

export default function ArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/articles")
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-insights" className="bg-paper min-h-screen">
      <SEO
        title="Insights"
        description="Long-form strategy notes on marketplaces, gaming, space-tech, food-tech and enterprise AI transformation — written by Nimisha Mohan Srivastava."
        image="https://images.pexels.com/photos/14314638/pexels-photo-14314638.jpeg"
      />
      <Navbar />

      <section className="pt-32 pb-16 md:pt-40 md:pb-20 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-3">
            <p className="eyebrow text-gold mb-6">Insights</p>
          </div>
          <div className="md:col-span-9">
            <motion.h1
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-navy mb-8"
            >
              Strategy notes on the businesses re-shaping India.
            </motion.h1>
            <p className="text-lg text-ink-muted max-w-2xl leading-relaxed">
              Long-form pieces — Porter's Five Forces meets on-the-ground
              operating experience. Written to be useful to founders, boards
              and institutional investors.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-32">
        <div className="border-t border-rule">
          {loading && (
            <p
              data-testid="insights-loading"
              className="py-20 eyebrow text-ink-faint text-center"
            >
              Loading insights…
            </p>
          )}
          {!loading &&
            articles.map((a, i) => (
              <ArticleCard key={a.id} article={a} index={i} featured />
            ))}
          {!loading && articles.length === 0 && (
            <p
              data-testid="insights-empty"
              className="py-20 eyebrow text-ink-faint text-center"
            >
              No articles published yet.
            </p>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
